import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography, Grid, Select, MenuItem } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

class SelfPacedGradebookStudent extends Component {

    render() {
        const { events } = this.props
        return (
            <Table style={{ margin: '0px', padding: '0xp' }}>
                <TableHead>
                    <TableRow>
                        <TableCell className='cell'>Event</TableCell>
                        <TableCell className='cell'>Score</TableCell>
                        <TableCell className='cell'></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {this.props.courseEvents.map(event => {
                        return event.EventList.filter((event_info) => event_info.EventIsGraded && event_info.EventIsGradable).map((event_info) => {
 
                            return (
                                <TableRow key={event_info.company_calendar_event_id}>
                                    <TableCell className='cell'>{event_info.EventName}</TableCell>
                                    <TableCell className='cell'>{Number(event_info.EventScore).toFixed(1) + " / " + Number(event_info.EventTotalScore).toFixed(1)}</TableCell>
                                    <TableCell className='cell'>
                                        <IconButton
                                            onClick={() => this.props.history.push('/' + event_info.EventType.toLowerCase() + '/student/' + event_info.company_calendar_event_id)}
                                            style={{ padding: '0px' }}
                                        >
                                            <Icon>search</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    })
                    }
                    <TableRow>
                        <TableCell className='cell'><a href={'/gradebook/student/event_list/' + this.props.course.company_calendar_course_id}>See All</a></TableCell>
                        <TableCell className='cell'></TableCell>
                        <TableCell className='cell'></TableCell>
                        <TableCell className='cell'></TableCell>
                    </TableRow>
                </TableBody>

            </Table>
        )
    }
}

export default (SelfPacedGradebookStudent);


// WEBPACK FOOTER //
// src/main/content/dashboard/CourseDashboard/SelfPacedGradebookStudent.js